import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type CertificateDTO = {
    studentId: string;
    courseId: string;
    instructorId: string;
};

export type CertificateResponse = {
    id: string;
    student: {
        id: string;
        firstName: string;
        lastName: string;
    };
    instructor: {
        firstName: string;
        lastName: string;
    };
    courseName: string;
    from: string;
    to: string;
} & ApiError;

export const CreateCertificate = (
    data: CertificateDTO
): Promise<CertificateResponse> => {
    return axios.post("/certification/getCertiicationForOneStudent", data);
};
